import { validationIsEqual } from '../status';
import {
    validateDateOfBirth,
    validateName,
    validateContactNumber,
    validateAlphaNumericStringAllowingOnlyNumbers,
    validateKraPinNumber,
    validateNumericString,
    validateNumber,
    validateAlphaNumericString,
} from '@om/validation';
import {
    FIRST_NAME_SET_VALUE,
    LAST_NAME_SET_VALUE,
    DOB_SET_VALUE,
    ID_NUMBER_SET_VALUE,
    TIN_NUMBER_SET_VALUE,
    PHONE_NUMBER_SET_VALUE,
    STREET_ADDRESS_SET_VALUE,
    CITY_SET_VALUE,
    SUBURB_SET_VALUE,
    POSTAL_ADDRESS_SET_VALUE,
    setIdNumberValid,
    setPostalAddressValid,
    setFirstNameValid,
    setLastNameValid,
    setPhoneNumberValid,
    setDOBValid,
    setTinNumberValid,
    setCityValid,
    setSuburbValid,
    setStreetAddressValid,
    GENDER_SET_VALUE,
    setGenderValid,
    MARITAL_STATUS_SET_VALUE,
    setMaritalStatusValid,
    NIHF_NUMBER_SET_VALUE,
    setNihfNumberValid,
} from '../../../actions/afyaImara/personalDetails';
import { getQuote } from '../../../selectors/afyaImara/quote';

export function validateKenyanIDOrPassport(value) {
    // ID: 8 to 15 digits
    const idPattern = /^[0-9]{8,15}$/;
    
    // Passport: 1 to 2 letters followed by 4 to 8 digits, total length 6 to 8
    const passportPattern = /^[A-Z]{1,2}[0-9]{4,8}$/;

    // Check if it's a valid ID
    if (idPattern.test(value)) {
        return null;
    }

    // Check if it's a valid Passport
    if (passportPattern.test(value)) {
        return null;
    }

    // Return specific error messages
    if (value.length < 6) {
        return "The input is too short. Minimum length is 6 characters for passports and 8 characters for IDs.";
    }
    if (value.length > 15) {
        return "The input is too long. Maximum length is 15 characters for IDs and 8 characters for passports.";
    }
    if (!/^[A-Z0-9]+$/.test(value)) {
        return "The input should contain only letters and digits.";
    }
    if (/^[A-Z]{3,}/.test(value)) {
        return "Passports should have 1 to 2 letters at the beginning.";
    }
    if (/^[A-Z]{1,2}[0-9]{9,}$/.test(value)) {
        return "Passport numbers should have 4 to 8 digits after the letters.";
    }

    return "Invalid ID or passport format.";
}

let prevValidationAction = null;
export const personalDetailsValidation = (store, next, action) => {
    const quotation = getQuote(store.getState());
    const validationAction = (() => {
        let error;
        switch (action.type) {
            case FIRST_NAME_SET_VALUE:
                error = validateName(action.value, {
                    min: 2,
                    max: 48,
                    subject: 'First Name',
                });
                return setFirstNameValid(error);

                case GENDER_SET_VALUE:
                    error = validateName(action.value, {
                        min: 2,
                        max: 48,
                        subject: 'Gender',
                    });
                    return setGenderValid(error);


                    case MARITAL_STATUS_SET_VALUE:
                    error = validateName(action.value, {
                        min: 2,
                        max: 48,
                        subject: 'Marital Status',
                    });
                    return setMaritalStatusValid(error);

                    case NIHF_NUMBER_SET_VALUE:
                    error = validateNumericString(action.value, {
                        min: 7,
                        subject: 'SHIF Number',
                    });
                    return setNihfNumberValid(error);

            case DOB_SET_VALUE:
                console.log(quotation)
                error = validateDateOfBirth(action.value, { min: quotation.productId === '2' ? 65 : 18, max: quotation.productId === '2' ? 85 : 65 });
                return setDOBValid(error);

            case PHONE_NUMBER_SET_VALUE:
                error = validateContactNumber(action.value, {
                    subject: 'Phone Number',
                    required: true,
                    countryCode: 'ke',
                });
                return setPhoneNumberValid(error);

            case ID_NUMBER_SET_VALUE:
                error = validateKenyanIDOrPassport(action.value);
                return setIdNumberValid(error);

            case TIN_NUMBER_SET_VALUE:
                error = validateKraPinNumber(action.value);
                return setTinNumberValid(error);

            case STREET_ADDRESS_SET_VALUE:
                error = validateAlphaNumericString(action.value, {
                    min: 2,
                    max: 64,
                    subject: 'Street Address',
                });
                return setStreetAddressValid(error);

            case CITY_SET_VALUE:
                error = validateName(action.value, {
                    min: 2,
                    max: 64,
                    subject: 'Street Address',
                });
                return setCityValid(error);

            case SUBURB_SET_VALUE:
                error = validateName(action.value, {
                    min: 2,
                    max: 64,
                    subject: 'Suburb',
                });
                return setSuburbValid(error);

            case POSTAL_ADDRESS_SET_VALUE:
                error = validateAlphaNumericStringAllowingOnlyNumbers(action.value);
                return setPostalAddressValid(error);

            default:
                return null;
        }
    })();

    if (!validationAction || validationIsEqual(validationAction, prevValidationAction)) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
